import {ConvenienceStoreInfo, ConvenienceStoreKey, ErrorMessagesForPaymentMethodInput} from '../../../../Props/ContractInputInfo'
import React from 'react'
import {Spacer} from '../../../../../Common/Components/Spacer'
import {MBMemberSelect} from '../../../Atoms/MBMemberSelect'
import {PIMWarningMessages} from '../../../Atoms/Labels/PIMWarningMessages'
import {MBContentNoteWithMarkTypography} from '../../../Atoms/Typographies'
import {PIMStack} from '../../../Atoms/Layouts/Bases/PIMStack'

export type ErrorMessageForConvenienceStoreInput =
  Pick<ErrorMessagesForPaymentMethodInput, 'convenienceStoreErrors'>

type ConvenienceStoreInputComponentForProps = {
  convenienceStoreInputInfo: ConvenienceStoreInfo
  errorMessage: ErrorMessageForConvenienceStoreInput
  onChangeInputDetailInfo: (changeInputDetailInfo: ConvenienceStoreInfo) => void
}

// noinspection SpellCheckingInspection
export const convenienceStoreList: { convenienceStoreKey: ConvenienceStoreKey, name: string }[] = [
  {convenienceStoreKey: 'lawson', name: 'ローソン'},
  {convenienceStoreKey: 'familymart', name: 'ファミリーマート'},
  {convenienceStoreKey: 'ministop', name: 'ミニストップ'},
  {convenienceStoreKey: 'seicomart', name: 'セイコーマート'},
]

export const convenienceStoreKeyToName = (key: ConvenienceStoreKey): string => {
  return convenienceStoreList.find(cvs => cvs.convenienceStoreKey === key)?.name ?? ''
}

export const ConvenienceStoreInputComponent: React.VFC<ConvenienceStoreInputComponentForProps>
  = (props) => {
  const convenienceStoreInfoState = props.convenienceStoreInputInfo
    || {
      convenienceStoreKey: '',
    } as ConvenienceStoreInfo

  function updateConvenienceStoreInfo(
    name: string, value: string, convenienceStoreInfo: ConvenienceStoreInfo,
  ): ConvenienceStoreInfo {
    return {
      ...convenienceStoreInfo,
      [name]: value,
    }
  }

  function handleChangeSelect(
    e: React.ChangeEvent<HTMLSelectElement>, convenienceStoreInfo: ConvenienceStoreInfo,
  ): ConvenienceStoreInfo {
    const {name, value} = e.target
    return updateConvenienceStoreInfo(name, value, convenienceStoreInfo)
  }

  return (
    <Spacer ml={'10%'} dataTestId={'block-input-convenience-store-information'}>
      <PIMStack spacing={'10px'}>
        <Spacer mt={'18px'}>
          <label htmlFor="payment-04">お支払い先コンビニ</label>
        </Spacer>
        <div style={{maxWidth: '300px'}}>
          <MBMemberSelect
            id="payment-04"
            name="convenienceStoreKey"
            value={convenienceStoreInfoState.convenienceStoreKey}
            hasError={props.errorMessage.convenienceStoreErrors.length > 0}
            onChange={(e): void => {
              props.onChangeInputDetailInfo(
                handleChangeSelect(e, convenienceStoreInfoState),
              )
            }}
          >
            <option value="" hidden disabled>選択してください</option>
            {convenienceStoreList.map((item) => (
              <option key={item.convenienceStoreKey} value={item.convenienceStoreKey}>
                {item.name}
              </option>
            ))}
          </MBMemberSelect>
        </div>
        {props.errorMessage.convenienceStoreErrors.length > 0 && (
          <Spacer mt={'12px'}>
            <PIMWarningMessages messages={props.errorMessage.convenienceStoreErrors}/>
          </Spacer>
        )}
        <PIMStack spacing={'4px'}>
          <MBContentNoteWithMarkTypography note={'コンビニ店頭でのお支払い後、入会が完了します。'}/>
          <MBContentNoteWithMarkTypography note={'お支払い完了から入会が完了するまでに時間がかかる場合があります。'}/>
        </PIMStack>
      </PIMStack>
      <Spacer mb={'18px'}/>
    </Spacer>
  )
}
